<mat-card style="min-height: 500px">
    <mat-card-content>
        <div class="max-width">
            <div class="row mt-2">
                <ng-container>
                    <div class="col-md-12 d-flex gap-3">
                        <button class="action-btn action-btn-create" role="button" (click)="onOpenModelAddSchoolProgram()" *ngIf="auth.permissions['SCHOOL_PROGRAM_ADD']">
                            {{ 'ADD_SCHOOL_PROGRAM' | translate }}
                        </button>
                        <button class="action-btn action-btn-edit" role="button" (click)="onOpenSchoolProgramGrid()" *ngIf="auth.permissions['SCHOOL_PROGRAM_ADD']">
                            {{ 'BULK_ADD_SCHOOL_PROGRAM' | translate }}
                        </button>
                        <button class="action-btn action-btn-create" role="button" (click)="onOpenModelAddCategory()" *ngIf="auth.permissions['SCHOOL_PROGRAM_CATEGORY_ADD']">
                            {{ 'ADD_CATEGORIES' | translate }}
                        </button>
                    </div>
                </ng-container>
            </div>
            <div class="row">
                <div class="col-8">
                </div>
                <div class="col-4 text-end mb-3">
                    <input type="text" [(ngModel)]="searchText" placeholder="{{ 'SEARCH' | translate }}" (ngModelChange)="filter($event)" class="form-control">
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <app-select-school-level-relation-v2 (schoolLevelRelationChanged)="onChangeSchoolLocation($event)"
                    [academic_year]="currentAcademic?.academic_year ?? null">

                    </app-select-school-level-relation-v2>
                </div>
            </div>

            <div *ngIf="paramForm.get('school_location_id')?.value">
                <school-program-table
                        [search]="searchText"
                        [triggerChanges]="changes"
                        [school_location_id]="this.paramForm.get('school_location_id')?.value"
                ></school-program-table>
            </div>
        </div>
    </mat-card-content>
</mat-card>

<ng-template #addSchoolProgram let-modal let-close="close">
    <form #programForm (ngSubmit)="onAddSchoolProgram()" [formGroup]="addProgramForm">
        <div class="modal-header">
            <div class="row">
                <div class="col-md-12">
                    <h5 class="modal-title">{{ 'ADD_SCHOOL_PROGRAM' | translate }}</h5>
                </div>
            </div>
        </div>
        <ng-container>
            <div class="modal-body">
                <div class="p-3">

                    <div class="row mb-2">
                        <div class="col-md-6">
                            <app-select-academic-year-only
                                    (academicYearChanged)="onChangeAcademicYear($event, 'addProgram')">
                            </app-select-academic-year-only>
                        </div>
                        <div class="col-md-6">
                            <app-select-school-level-relation-v2
                                    [isDisabled]="!addProgramForm.get('academic_year')?.value"
                                    [academic_year]="addProgramForm.get('academic_year')?.value"
                                    (schoolLevelRelationChanged)="onChangeSchoolLocation($event, 'addProgram')"
                                    [addAllToList]="true">
                            </app-select-school-level-relation-v2>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'SCHOOL_PROGRAM_NAME' | translate }}<span style="font-size: 16px; color: rgb(190, 0, 0);">*</span></span>
                            <input placeholder="{{ 'SCHOOL_PROGRAM_NAME_PLACEHOLDER' | translate }}"
                                class="form-control p-3 fs-14 border-1 rounded h-25 w-100"
                                style="outline: none;" formControlName="school_program_name">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'SCHOOL_PROGRAM_DESCRIPTION' | translate }}<span style="font-size: 16px; color: rgb(190, 0, 0);">*</span></span>
                            <textarea class="form-control" rows="3" placeholder="{{ 'SCHOOL_PROGRAM_DESCRIPTION_PLACEHOLDER' | translate }}" formControlName="school_program_description"></textarea>
                        </div>
                    </div>

                    <div class="d-flex justify-content-center">
                        <button type="submit" [disabled]="disableProgramSubmit" class="action-btn action-btn-create col-md-2 mt-3 me-1">
                            {{ 'SAVE' | translate }}
                        </button>
                    </div>
                </div>
            </div>
        </ng-container>

    </form>
</ng-template>

<ng-template #addCategory let-modal let-close="close">
    <form #categoryForm (ngSubmit)="onAddCategory()" [formGroup]="addCategoryForm">
        <div class="modal-header">
            <div class="row">
                <div class="col-md-12">
                    <h5 class="modal-title">{{ 'ADD_CATEGORY' | translate }}</h5>
                </div>
            </div>
        </div>

        <ng-container>
            <div class="modal-body">
                <div class="p-3">
                    <div class="row mb-2">
                        <div class="col-md-6">
                            <app-select-school-level-relation-v2
                                    [academic_year]="currentAcademic?.academic_year ?? null"
                                    (schoolLevelRelationChanged)="onChangeSchoolLocation($event, 'addCategory')"
                                    [isDisabled]="!currentAcademic">

                            </app-select-school-level-relation-v2>
                        </div>
                    </div>
                    
                    <div class="row">
                        <div class="col-md-6 mb-2">
                            <app-select-school-program
                                    [academic_year]="currentAcademic?.academic_year ?? null"
                                    (schoolProgramChanged)="onChangeSchoolProgram($event)"
                                    [school_location_id]="this.addCategoryForm.get('school_location_id')?.value"
                                    [isDisabled]="!currentAcademic"
                            >

                            </app-select-school-program>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'CATEGORY_NAME' | translate }}<span style="font-size: 16px; color: rgb(190, 0, 0);">*</span></span>
                            <input placeholder="{{ 'CATEGORY_NAME_PLACEHOLDER' | translate }}"
                                class="form-control p-3 fs-14 border-1 rounded h-25 w-100"
                                style="outline: none;" formControlName="category_name">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'CATEGORY_DESCRIPTION' | translate }}<span style="font-size: 16px; color: rgb(190, 0, 0);">*</span></span>
                            <textarea class="form-control" rows="3" placeholder="{{ 'CATEGORY_DESCRIPTION_PLACEHOLDER' | translate }}" formControlName="category_description"></textarea>
                        </div>
                    </div>

                    <div class="d-flex justify-content-center">
                        <button type="submit" class="action-btn action-btn-create col-md-2 mt-3 me-1"
                        [disabled]="disableCategorySubmit">
                            {{ 'SAVE' | translate }}
                        </button>
                    </div>
                </div>
            </div>
        </ng-container>

    </form>
</ng-template>
